import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import betaLogo from './alumsumlogobetatm.png';
import logo from './alumsumlogotm.png';
import './Header.scss';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.data.userInfo
        };
        console.log('Header user info:', this.state.user[0]);
    }

    render() {
        const user = this.state.user[0];
        const displayName = user.firstName && user.firstName.length >= 2
            ? user.firstName
            : user.userEmail;

        return (
            <div className="header text-center mr-t40 mr-b30 wd-100">
                <Link to='/'><img src={logo} alt="logo" /></Link>
        <div className="welcome-text mr-t30">Welcome to your student dashboard, <span className="country-name">{displayName}</span></div>
            </div>
        )
    }
}

export default Header;
